import React from 'react';
import { injectIntl } from 'react-intl';
import ScrollArea from 'react-scrollbar';

class SepaAgreement extends React.Component {
  render() {
    const {
      intl: { messages },
      owner,
      target,
    } = this.props;

    return (
      <ScrollArea
        speed={0.8}
        className="b-a b-grey"
        contentClassName=""
        horizontal={false}
        style={{ overflow: 'hidden', height: '300px' }}
      >
        <div class="padding-20">
          <h3>{messages.sepaAgreement.sepa_direct_debit_mandate}</h3>

          <h4>{messages.sepaAgreement.mandate_reference}</h4>
          <dl>
            <dt>{messages.sepaAgreement.will_be_communicated_separately}</dt>
            <dd>{''}</dd>
          </dl>

          <h4>{messages.sepaAgreement.payee}</h4>
          <dl>
            <dt>{messages.sepaAgreement.creditor}</dt>
            <dd>{owner.company}</dd>

            <dt class="m-t-5">{messages.creditor_id}</dt>
            <dd>{owner.creditor_id}</dd>
          </dl>

          <p>{messages.sepaAgreement.i_allow_payee_direct_debit}</p>
          <p>{messages.sepaAgreement.note_i_can_claim_reimbursement_within_eight_weeks}</p>

          <h4>{messages.sepaAgreement.payer}</h4>
          <dl>
            <dt>{messages.account_holder}</dt>
            <dd>{target.profile.company}</dd>

            <dt class="m-t-5">{messages.street + ' / ' + messages.house_number}</dt>
            <dd>
              {target.profile.street}
              {target.profile.house_number ? ' ' + target.profile.house_number : null}
              {target.profile.apartment_number ? ' ' + target.profile.apartment_number : null}
            </dd>

            <dt class="m-t-5">{messages.zip_code}</dt>
            <dd>{target.profile.zip_code}</dd>

            <dt class="m-t-5">{messages.city}</dt>
            <dd>{target.profile.city}</dd>

            <dt class="m-t-5">{messages.country}</dt>
            <dd>{target.profile.country_name}</dd>

            <dt class="m-t-5">
              {messages.iban} ({messages.account_number})
            </dt>
            <dd>{target.financial.bank_data.iban}</dd>

            <dt class="m-t-5">{messages.swift_bic}</dt>
            <dd>{target.financial.bank_data.swift_bic}</dd>
          </dl>

          <p>{target.profile.city}</p>
          <p>
            <i>{messages.sepaAgreement.document_issued_electronically_and_valid_without_signature}</i>
          </p>

          <h4>{messages.sepaAgreement.shortening_notice_period}</h4>
          <p>{messages.sepaAgreement.deadline_for_advance_information_of_direct_debit_is_shortened_to_one_day}</p>
        </div>
      </ScrollArea>
    );
  }
}

export default injectIntl(SepaAgreement);
